<template>
  <v-container fluid>
    <main id="main" class="site-main">
      <!-- pesquisa -->
      <section id="search" class="search site-section">
        <search />
      </section>
      <!-- indicadores -->
      <section id="indicators" class="site-section">
        <indicators />
      </section>
      <!-- publicacoes -->
      <section id="publications" class="site-section">
        <publications />
      </section>
    </main>
  </v-container>
</template>

<script>
import search from "@/components/search";
import publications from "@/components/publications";
import indicators from "@/components/indicators";
export default {
  name: "Home",
  components: {
    search,
    publications,
    indicators,
  },
};
</script>